// Detect whether the web app is running inside the native mobile app's WebView
// shell (iOS/Android). The native shell loads canira.io routes with `?embedded=1`
// and injects `window.ReactNativeWebView` before the page boots.
//
// Why this matters: Apple App Store Guideline 3.1.1 forbids sending users to an
// external payment provider (Stripe) for digital goods from inside the app. Any
// code that would redirect to Stripe checkout / billing portal MUST first check
// isEmbedded() and refuse when true. Detection mirrors the logic in App.js
// (which persists the flag in sessionStorage so in-app navigation that drops the
// query param stays embedded for the rest of the session).
export function isEmbedded() {
  if (typeof window === 'undefined') return false;
  // The native shell injects this before page load — strongest signal we're
  // inside the app, even on routes that never carried the query param.
  if (window.ReactNativeWebView) return true;
  try {
    if (new URLSearchParams(window.location.search).has('embedded')) return true;
  } catch (_) {
    /* malformed query string — fall through */
  }
  try {
    return sessionStorage.getItem('canira.embedded') === '1';
  } catch (_) {
    return false;
  }
}

export default isEmbedded;
